"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var react_content_loader_1 = __importDefault(require("react-content-loader"));
var useStyles = styles_1.makeStyles({
    root: {
        background: 'white',
        display: 'block',
        height: 'auto',
        width: '100%',
    },
});
var LINE_COUNT = 40;
var MARGIN_RATIO = 1 / 12;
var LINE_LENGTHS = [0.5, 0.85, 1];
var DocumentPageSkeleton = function (_a) {
    var pageHeight = _a.pageHeight, pageWidth = _a.pageWidth;
    var leftMargin = pageWidth * MARGIN_RATIO;
    var topMargin = pageHeight * MARGIN_RATIO;
    var linePitch = (pageHeight - topMargin * 2) / LINE_COUNT;
    var classes = useStyles();
    return (react_1.default.createElement(react_content_loader_1.default, { className: classes.root, foregroundColor: "#ecebeb", speed: 1, viewBox: "0 0 " + pageWidth + " " + pageHeight }, Array.from({ length: LINE_COUNT }, function (__, i) {
        var y = topMargin + i * linePitch;
        var lineWidth = LINE_LENGTHS[i % LINE_LENGTHS.length] * pageWidth - 2 * leftMargin;
        var lineHeight = linePitch / 2;
        return (react_1.default.createElement("rect", { height: lineHeight, key: i, rx: "3", ry: "3", width: lineWidth, x: leftMargin, y: y }));
    })));
};
exports.default = DocumentPageSkeleton;
//# sourceMappingURL=DocumentPageSkeleton.js.map